export default __webpack_public_path__ + "static/media/heroD.6e660a50.jpg";